/**
 * Cultural Aspects Components
 * Exports all cultural aspects related components
 */

export { CulturalAspectsSection } from './CulturalAspectsSection';
export { CulturalAspectItem } from './CulturalAspectItem';
export { CulturalAspectList } from './CulturalAspectList';

// Export types
export type { CulturalAspectsSectionProps, CulturalAspect } from './types';
